module.exports = __webpack_public_path__ + "img/gradient-orange-pink-white.b6b78ad.jpg";